<template>
  <base-modal
    class="modal-teacher"
    title="Create Teacher Profile"
    @close="$emit('close')"
    data-test-id="edit-profile-modal"
  >
    <form class="modal-teacher__form" @submit.prevent="save" data-test-id="profile-info-form">
      <form-control label="Basic Information" theme="dark" data-test-id="information-section">
        <div class="modal-teacher__columns">
          <div class="modal-teacher__column-3">
            <label for="name">Name</label>
          </div>
          <div class="modal-teacher__column-7">
            <text-field :invalid="hasErrors" v-model="model.name" theme="dark" data-test-id="name-input"></text-field>
          </div>
        </div>
        <div class="modal-teacher__columns">
          <div class="modal-teacher__column-3">
            <label for="email">E-mail</label>
          </div>
          <div class="modal-teacher__column-7">
            <text-field :invalid="hasErrors" v-model="model.email" theme="dark" data-test-id="email-input"></text-field>
          </div>
        </div>
      </form-control>

      <div class="modal-teacher__submit">
        <p v-if="errors.length" data-test-id="error-message">{{ errors }}</p>
        <voxy-button
          view="primary"
          type="submit"
          size="s"
          :disabled="$v.model.$invalid || isSaving"
          data-test-id="submit-button"
        >
          {{ isSaving ? 'Saving...' : 'Save' }}
        </voxy-button>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { VoxyButton } from '@voxy-team/vue-voxy';
import { email, required } from 'vuelidate/lib/validators';

import FormErrorMapper from '@/mixins/FormErrorMapper';

import BaseModal from '@/components/BaseModal';
import FormControl from '@/components/form/FormControl';
import TextField from '@/components/form/TextField';

export default {
  name: 'ModalTeacherCreate',

  components: {
    BaseModal,
    FormControl,
    VoxyButton,
    TextField,
  },

  mixins: [FormErrorMapper],

  data() {
    return {
      errors: {},
      hasErrors: false,
      isSaving: false,
      model: {
        name: '',
        email: '',
      },
    };
  },

  validations: {
    model: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      createTeacherProfile: 'CREATE_TEACHER_PROFILE',
    }),

    async save() {
      this.errors = {};

      try {
        const profile = await this.createTeacherProfile({
          value: this.model,
        });

        this.$router.push({
          name: 'manage_teachers_profile',
          params: {
            teacherHashEmail: profile.teacher_hashed_email,
          },
        });

        this.$emit('close');
      } catch (errors) {
        this.errors = JSON.stringify(errors);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/components/teacher-management-sections';
</style>
